export default __webpack_public_path__ + "static/media/Flag_of_Togo.20bbe973.svg";